"use strict";

$(function () {
  $('.slider-product').each(function (index, element) {
    var tagArrowLeft = $(element).data('tag-arrow-left');
    var tagArrowRight = $(element).data('tag-arrow-right');
    $(element).on('init', function (event, slick, direction) {
      $('.slick-slide a', $(element)).each(function (index2, element2) {
        var id = $(element2).data('id');
        $(element2).attr('id', id);
      });
      checkSliderNote($(element));
    });
    $(element).on('breakpoint', function (event, slick, breapoint) {
      checkSliderNote($(element));
    });
    $(element).slick({
      dots: false,
      arrows: true,
      mobileFirst: true,
      slidesToShow: 2.5,
      slidesToScroll: 2,
      infinite: false,
      prevArrow: "<button class='slick-prev slick-arrow' aria-label='Previous' type='button' style='' id='" + tagArrowLeft + "'><div class='arrow'></div>Previous</button>",
      nextArrow: "<button class='slick-next slick-arrow' aria-label='Next' type='button' style='' id='" + tagArrowRight + "'><div class='arrow'></div>Next</button>",
      appendArrows: $('.container-arrows-products .arrows', $(element).closest('.row')),
      responsive: [{
        breakpoint: 540,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      }]
    });
    checkSliderNote($(element));
  });
  function checkSliderNote($element) {
    var $row = $($element).closest('.row');
    if ($('.container-arrows-products .arrows', $row).text().trim() == '') {
      $('.slider-note', $row).hide();
      $('.container-arrows-products', $row).hide();
    } else {
      $('.slider-note', $row).show();
      $('.container-arrows-products', $row).show();
    }
  }
});